import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { authMe } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();

  useEffect(() => {
    authMe().then(() => navigate("/admin", { replace: true })).catch(() => {});
  }, [navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6">
      <div className="max-w-md w-full text-center space-y-10">
        <Logo variant="dark" size="lg" />
        <div className="space-y-4">
          <div className="sc-overline">Area Riservata</div>
          <h1 className="font-display font-light text-3xl" style={{ letterSpacing: "-0.02em" }}>
            Accesso pannello di controllo
          </h1>
          <p className="text-sm text-neutral-500 leading-relaxed">
            L'accesso è riservato agli amministratori SuiteCrowd. Autenticati con
            il tuo account Google autorizzato.
          </p>
        </div>
        <button
          data-testid="admin-google-login-btn"
          onClick={handleLogin}
          className="sc-btn-primary inline-flex items-center gap-3"
        >
          Accedi con Google
        </button>
        <div className="pt-6 text-[11px] text-neutral-400 tracking-[0.2em] uppercase">
          <a href="/" className="hover:text-neutral-700 transition-colors">
            ← Torna al club
          </a>
        </div>
      </div>
    </div>
  );
}
